import { CircleArrowRight } from "lucide-react";
import React from "react";
import moment from "moment";
import { InboxQueryDetails, QueryCategory } from "../utils/types";

interface QueryDetailsListProps {
  ticket: InboxQueryDetails;
}
const QueryDetailsData = ({ ticket }: QueryDetailsListProps): JSX.Element => {
  const queryTypeTitle = (): string => {
    if (ticket.category === QueryCategory.LEAVE) {
      return "Leave request details";
    }
    return "Query details";
  };
  return (
    <div className="flex pb-6 border-b border-jem-shade">
      <CircleArrowRight size={24} className="text-jem-primary-base" />
      <div className="flex flex-col gap-6 pl-4">
        <h3 className="text-lg font-bold leading-none text-jem-primary-base mt-[1px]">
          {queryTypeTitle()}
        </h3>

        {/* Legacy: Display any additional information from the old chatbot system.
                    For newer WhatsApp Flows, this data would be captured in ticket.data instead */}
        {ticket.query_reason && (
          <div className="flex flex-col">
            <span className="text-xs text-jem-primary-50t">Query reason</span>
            <span className="text-[16px] text-jem-primary-base">
              {ticket.query_reason}
            </span>
          </div>
        )}
        {ticket.site_name && (
          <div className="flex flex-col">
            <span className="text-xs text-jem-primary-50t">Site</span>
            <span className="text-[16px] text-jem-primary-base">
              {ticket.site_name}
            </span>
          </div>
        )}
        {ticket.other_information && (
          <div className="flex flex-col">
            <span className="text-xs text-jem-primary-50t">
              Other information
            </span>
            <span className="text-[16px] text-jem-primary-base">
              {ticket.other_information || "None"}
            </span>
          </div>
        )}

        {/* WhatsApp Flow: Display structured data collected during the WhatsApp conversation.
                    Each data item contains a key, label, and value captured during the flow.
                    Only shows items that have a non-null value */}
        {ticket.data?.length > 0 &&
          ticket.data
            .filter((ticketData) => ticketData.value) // Filter out items with no value
            .map((ticketData) => (
              <div className="flex flex-col" key={ticketData.key}>
                <span className="text-xs text-jem-primary-50t">
                  {ticketData.label}
                </span>
                <span className="text-[16px] text-jem-primary-base">
                  {ticketData.value ?? "None"}
                </span>
              </div>
            ))}
        <div className="flex flex-col">
          <span className="text-xs text-jem-primary-50t">Submission date</span>
          <span className="text-[16px] text-jem-primary-base">
            {moment(ticket.date_created).format("DD MMMM YYYY")}
          </span>
        </div>

        {/**
         * Document Query Specific Fields
         */}
        {ticket.issue_date && (
          <div className="flex flex-col">
            <span className="text-xs text-jem-primary-50t">
              {ticket.query_type} issue date
            </span>
            <span className="text-[16px] text-jem-primary-base">
              {moment(ticket.issue_date).format("DD MMMM YYYY")}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
export default QueryDetailsData;
